import { VehicleDetailsDto } from "@1games-ru/region-shared/dist/types/vehicle/vehicle-b";
import { motion } from "motion/react";
import VehicleDetailsDepricated from "@/shared/widgets/VehicleDetailsDepricated";

type Props = {
  vehicle: VehicleDetailsDto;
  onCharacterDetach?: (vehicleId: number, characterId: number) => void;
  isDetaching: boolean;
};

export default function EstateVehicleInfo({ vehicle, onCharacterDetach, isDetaching }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, translateX: "100%" }}
      animate={{ opacity: 1, translateX: "none" }}
      transition={{ duration: 0.2, ease: "easeOut" }}
    >
      <VehicleDetailsDepricated
        vehicle={vehicle}
        isDetaching={isDetaching}
        onCharacterDetach={onCharacterDetach}
      />
    </motion.div>
  );
}
